import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
} from '@mui/material';
import useDialog from 'hooks/useDialog';
import { ArchivedStatus } from '../ApplicationStatusControl';
import { ProfessionalArchiveReasonEnum } from 'typings/enums';
interface ArchiveItemProps {
  updateApplicationStatus: (val: any) => void;
}

const ArchiveItem = ({ updateApplicationStatus }: ArchiveItemProps) => {
  const { open, closeDialog, openDialog } = useDialog();

  return (
    <>
      <MenuItem onClick={openDialog}>Archive</MenuItem>
      <ArchiveDialog
        open={open}
        closeDialog={closeDialog}
        updateApplicationStatus={updateApplicationStatus}
      />
    </>
  );
};

const ArchiveDialog = ({ open, closeDialog, updateApplicationStatus }) => {
  const [archiveReason, setArchiveReason] = useState('');
  const submitUpdateApplicationStatus = () => {
    updateApplicationStatus({
      application_status: ArchivedStatus,
      archive_reason: archiveReason,
    });
  };

  return (
    <Dialog open={open} onClose={closeDialog}>
      <DialogTitle>Archive Reason</DialogTitle>
      <DialogContent>
        <Select
          fullWidth
          value={archiveReason}
          label="Select Archive Reason"
          onChange={({ target }) => setArchiveReason(target.value as string)}
          required
          style={{ width: '550px', marginBottom: '20px' }}
        >
          {Object.keys(ProfessionalArchiveReasonEnum).map((reason) => (
            <MenuItem key={reason} value={ProfessionalArchiveReasonEnum[reason]}>
              {reason}
            </MenuItem>
          ))}
        </Select>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeDialog}>Cancel</Button>
        <Button
          disabled={!archiveReason}
          onClick={submitUpdateApplicationStatus}
          color="primary"
          variant="contained"
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ArchiveItem;
